import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class PublishDraftService extends Service {
  constructor({
    config,
    errorsPublishDraftVOFactory,
    fromPublishDraftResponseToUrlValueObjectMapper,
    getInstantOfferByAdService,
    repository
  }) {
    super()
    this._config = config
    this._adPublisherConfig = this._config.get('adPublisher')
    this._publishDraftResponseCodes = this._adPublisherConfig.publishDraftResponseCodes
    this._errorsPublishDraftVOFactory = errorsPublishDraftVOFactory
    this._fromPublishDraftResponseToUrlValueObjectMapper = fromPublishDraftResponseToUrlValueObjectMapper
    this._getInstantOfferByAdService = getInstantOfferByAdService
    this._repository = repository
  }

  /**
   * @return {Promise<DraftEntity, Error>} returns the draft entity
   */
  @inlineError
  async execute({
    categoryId,
    requestDraftVO,
    // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
    isGetAvailableFreeAdsEnabled
  }) {
    const {DEFAULT_USER_AD_CATEGORY, USER_AD_CATEGORIES_WITH_DRAFT, USER_AD_CATEGORIES_WITH_INSTANT_OFFER} =
      this._config.get('seller')
    const userAdCategory = categoryId ?? DEFAULT_USER_AD_CATEGORY
    const publishParams = {categoryId, requestDraftVO}

    const [publishError, publishResponse] = USER_AD_CATEGORIES_WITH_DRAFT.includes(userAdCategory)
      ? await this._repository.publishDraft(publishParams)
      : await this._repository.publishAd(publishParams)

    const {code, errors} = publishError
      ? publishError.toJSON()
      : {
          code: publishResponse.getResultCode()
        }

    if (errors && errors.length) {
      return this._errorsPublishDraftVOFactory({errors})
    }

    const adId = requestDraftVO.getAdId()
    let isInstantOfferTarget = false

    if (code === this._publishDraftResponseCodes.ok && USER_AD_CATEGORIES_WITH_INSTANT_OFFER.includes(userAdCategory)) {
      const [isInstantOfferTargetError] = await this._getInstantOfferByAdService.execute({
        adId,
        simulate: true
      })
      isInstantOfferTarget = Boolean(!isInstantOfferTargetError)
    }

    return this._fromPublishDraftResponseToUrlValueObjectMapper.map({
      code,
      id: adId,
      isInstantOfferTarget,
      // ff_web_seller_get_available_free_ads_on_publish_my_ad_page
      isGetAvailableFreeAdsEnabled
    })
  }
}
